<div class="activity-log"
[ngClass]="showSpinner == true ? 'show-spinner' : ''">
  <!-- <h5 class="ml-2">Trainee Activity Log :: {{action}} :: {{actionId}}</h5> -->
  <!-- <span>{{action}} :: {{actionId}}</span> -->
  <div class="actions-bar">
    <div class="log-actions">
      <ion-label>Filter by:</ion-label>
      <ion-toolbar class="btns-toolbar mt-0">
        <ion-buttons slot="start">
          <ion-button
            color="secondary"
            fill="solid"
            (click)="logActions($event)"
          >
            <fa-icon [icon]="faChevronDown" slot="end"></fa-icon>
            Actions&nbsp;&nbsp;
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </div>
    <div class="admin-actions">
      <ion-toolbar class="btns-toolbar mt-0">
        <ion-buttons slot="start">
          <ion-button
            color="secondary"
            fill="outline"
            (click)="adminActions($event)"
          >
            <fa-icon [icon]="faUsers" slot="start"></fa-icon>
            &nbsp;&nbsp; Admins &nbsp;&nbsp;
            {{selectedAdmins && selectedAdmins.length>0 ? selectedAdmins.length :''}} &nbsp;&nbsp;
            <fa-icon [icon]="faChevronDown" slot="end"></fa-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </div>
    <div class="date-actions">
      <ion-toolbar class="btns-toolbar mt-0">
        <ion-buttons slot="start">
          <ion-button
            color="secondary"
            fill="outline"
            (click)="dateActions($event)"
          >
            <fa-icon [icon]="faCalendarAlt" slot="start"></fa-icon>
            &nbsp;&nbsp; {{dateSortSelection}} &nbsp;&nbsp;
            <fa-icon [icon]="faChevronDown" slot="end"></fa-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </div>
    
  </div>
  <div class="ion-text-center pt-4 pb-4" *ngIf="showSpinner && fetchingApi">
    <ion-spinner name="lines"></ion-spinner>
  </div>
  <div class="wrapper" *ngIf="logs">
    <div class="logs">
      <div class="log" *ngFor="let log of logs">
        <div class="icon">
          <fa-icon
            *ngIf="log.json_data?.action == 'user'"
            [icon]="faUser"
          ></fa-icon>
          <fa-icon
            *ngIf="log.json_data?.action == 'application'"
            [icon]="faFileAlt"
          ></fa-icon>
          <fa-icon
            *ngIf="log.json_data?.action == 'department'"
            [icon]="faUniversity"
          ></fa-icon>
          <fa-icon
            *ngIf="log.json_data?.action == 'program'"
            [icon]="faTasks"
          ></fa-icon>
          <fa-icon
            *ngIf="log.json_data?.action == 'payment'"
            [icon]="faShoppingCart"
          ></fa-icon>
          <!-- 
          <fa-icon *ngIf="log.json_data?.action == 'host'" [icon]="faUserCircle"></fa-icon>
          <fa-icon *ngIf="log.json_data?.action == 'coupon'" [icon]="faTicketAlt"></fa-icon>
           -->
        </div>
        <div class="info">
          <ion-label class="action">{{
            log.json_data?.action == "user"
              ? "Profile/Account Action"
              : log.json_data?.name
          }} 
          <!-- ::: {{log.json_data?.action}} 
          ::: {{log.updatedAt}} -->
          </ion-label>
          <div class="msg-link">
            <ion-label class="txt">{{ log.json_data?.message }}</ion-label>
            <ion-label class="link" 
            (click)="openLink(log)" 
            *ngIf="linkDisplay( log.json_data?.action)"
            >Link</ion-label>
            <!-- <ion-label class="txt" *ngIf="log.json_data.changed_data">{{log.json_data?.changed_data | json}}</ion-label> -->
          </div>
        </div>
        <div class="date">
          <ion-label class="txt">
            <!-- {{log.updatedAt}} -->
            <!-- {{ log.updatedAt | date: "longDate" }} -->
            {{ log.updatedAt | date: "EE, MMM dd, y" }}
            <!-- {{ log.updatedAt | date: "mediumTime" }} -->
            {{ log.updatedAt | date: "hh:mm:ss a" }}
          </ion-label>
        </div>
      </div>
      <div *ngIf="logs && logs.length == 0">
        <h6 class="m-0">No Activity Logs</h6>
      </div>
    </div>
  </div>
</div>
